<section class="show-case">
  <div class="container">
    <h2 class="title-header">Datos</h2>
    <form #formData="ngForm" class="row align-items-center" (ngSubmit)="onSubmit(formData)">
      <!-- Nombre completo -->
      <div class="col-sm-6 col-md-6 mb-4">
        <label class="form-label" for="fullName">Nombre completo <span class="text-danger">*</span></label>
        <input class="form-control" id="fullName" name="fullName" [(ngModel)]="formDataModel.fullName" type="text"
          required [class.is-invalid]="(fullName.touched || formSubmitted) && !fullName.valid" #fullName="ngModel" [attr.disabled]="false" />
        <div *ngIf="(fullName.touched || formSubmitted) && !fullName.valid" class="invalid-feedback">Este campo es
          obligatorio.</div>
      </div>

      <!-- Cedula -->
      <div class="col-sm-6 col-md-6 mb-4">
        <label class="form-label" for="documentId">Cédula <span class="text-danger">*</span></label>
        <input mask="000-0000000-0" placeholder="000-0000000-0" class="form-control" id="documentId" name="documentId"
					[attr.disabled]="false" [(ngModel)]="formDataModel.documentId" type="text" required appMaskIdentification 
          [class.is-invalid]="(documentId.touched || formSubmitted) && !documentId.valid" #documentId="ngModel" />
        <div *ngIf="(documentId.touched || formSubmitted) && !documentId.valid" class="invalid-feedback">Este campo es
          obligatorio.</div>
      </div>

      <!-- Teléfono celular -->
      <div class="col-sm-6 col-md-3 mb-4">
        <label class="form-label" for="phone">Teléfono celular <span class="text-danger">*</span></label>
        <input [mask]="'000-000-0000'" maxlength="12" class="form-control" id="phone" name="phone"
          [(ngModel)]="formDataModel.phone" type="tel" placeholder="809-555-5555" required
          [class.is-invalid]="(phone.touched || formSubmitted) && (!phone.valid || phone.errors?.invalidPhone || phone.errors?.invalidAreaCode)"
          appAreaCodeDRValidator appPhoneValidator #phone="ngModel" />
        <div *ngIf="(phone.touched || formSubmitted)&& (!phone.valid || phone.errors?.invalidPhone)"
          class="invalid-feedback">
          <div *ngIf="phone.errors?.required">Este campo es obligatorio.</div>
          <div *ngIf="phone.errors?.invalidAreaCode">El código de área no es válido.</div>
          <div *ngIf="phone.errors?.invalidPhone">El número de teléfono debe tener al menos 10 dígitos.</div>
        </div>
      </div>

      <!-- Teléfono Casa -->
      <div class="col-sm-6 col-md-3 mb-4">
        <label class="form-label" for="phoneHome">Teléfono Casa</label>
        <input [mask]="'000-000-0000'" maxlength="12" class="form-control" id="phoneHome" name="phoneHome"
          [(ngModel)]="formDataModel.phoneHome" type="tel" placeholder="809-555-5555"
          [class.is-invalid]="(phoneHome.touched || formSubmitted) && (!phoneHome.valid || phoneHome.errors?.invalidPhone || phoneHome.errors?.invalidAreaCod)"
          appAreaCodeDRValidator appPhoneValidator #phoneHome="ngModel" />
        <div *ngIf="(phoneHome.touched || formSubmitted) && (!phoneHome.valid || phoneHome.errors?.invalidPhone)" class="invalid-feedback">
          <div *ngIf="phoneHome.errors?.invalidAreaCode">El código de área no es válido</div>
          <div *ngIf="phoneHome.errors?.invalidPhone">El número de teléfono debe tener al menos 10 dígitos.</div>
        </div>
      </div>

      <!-- Ingresos -->
      <div class="col-sm-6 col-md-3 mb-4">
        <label class="form-label">Ingresos <span class="text-danger">*</span></label>
        <input class="form-control" placeholder="RD$" type="text" mask="separator" thousandSeparator=","  appNoDecimals required
          name="salary" [(ngModel)]="formDataModel.salary"
          [class.is-invalid]="(salary.touched || formSubmitted) && !salary.valid" #salary="ngModel" />
        <div *ngIf="(salary.touched || formSubmitted) && !salary.valid" class="invalid-feedback">Este campo es requerido
        </div>
      </div>

      <!-- Email -->
      <div class="col-sm-6 col-md-3 mb-4">
        <label class="form-label" for="email">Email <span class="text-danger">*</span></label>
        <input class="form-control" id="email" name="email" [(ngModel)]="formDataModel.email" type="email"
          placeholder="ejemplo@gmail.com" required email
          [class.is-invalid]="(email.touched || formSubmitted) && (!email.valid || email.errors?.email)"
          #email="ngModel" />
        <div *ngIf="(email.touched || formSubmitted) && (!email.valid || email.errors?.email)" class="invalid-feedback">
          <span *ngIf="email.errors?.required">Este campo es obligatorio.</span>
          <span *ngIf="email.errors?.email">Por favor ingrese un correo electrónico válido.</span>
        </div>
      </div>

      <!-- Productos -->
      <div class="py-4">
        <p>
          Selecciona los productos de tu preferencia (pueden ser más de uno) <span class="text-danger">*</span>
        </p>
        <div class="invalid-feedback d-block" *ngIf="formSubmitted && formDataModel.selectionOpt.length <= 0">
          Este campo es obligatorio.
        </div>
        <div class="list">
          <div class="item form-check border-product" *ngFor="let product of optProduct">
            <input 
              id="{{product.name}}" 
              type="checkbox" 
              class="form-check-input" 
              (change)="selectOptProduct(product)"
              [checked]="formDataModel.selectionOpt.includes(product.id)"
            />
            <div class="icono-producto-container">
              <img 
                [src]="product.image" 
                alt="{{product.name}}" 
              />
              <label for="{{product.name}}">
                {{product.name}}
              </label>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Botones -->
      <div class="btns">
        <button type="button" [disabled]="isLoading" (click)="openDialogRechazo()" class="back-btn">Cancelar</button>
        <button type="submit" class="consult-btn">
          <span *ngIf="isLoading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span *ngIf="isLoading" [disabled]="isLoading"> Enviando... </span>
          <span *ngIf="!isLoading"> Enviar </span>
        </button>
      </div>
    </form>
  </div>
</section>